import React from 'react';
import { Link } from 'react-router-dom';
import './CopyrightFooter.css';

const CopyrightFooter = () => {
  return (
    <footer className="copyright-footer">
      <div className="copyright-footer-content">
        <p className="copyright-footer-text">
          &copy; 2026 Membrowse
          <span className="copyright-footer-separator"> | </span>
          <Link to="/terms" className="copyright-footer-link">Terms</Link>
          <span className="copyright-footer-separator"> | </span>
          <Link to="/terms-oss" className="copyright-footer-link">OSS Terms</Link>
          <span className="copyright-footer-separator"> | </span>
          <Link to="/privacy" className="copyright-footer-link">Privacy</Link>
        </p>
      </div>
    </footer>
  );
};

export default CopyrightFooter;
